/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPackageSubscription } from 'app/shared/model/package-subscription.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IPackagePaymentHistory {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  cursor?: number;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  paidByFirstName?: string | null;
  paidBySecondName?: string | null;
  subscription?: IPackageSubscription | null;
  paidBy?: IGlucoUser | null;
}

export const defaultValue: Readonly<IPackagePaymentHistory> = {
  active: false,
};
